function extendableError() {
  function ExtendableBuiltin() {
    Error.apply(this, arguments);
  }
  ExtendableBuiltin.prototype = Object.create(Error.prototype);
  Object.setPrototypeOf(ExtendableBuiltin, Error);

  return ExtendableBuiltin;
}

export class EmailTakenError extends extendableError() {
  constructor(...params) {
    super(...params);
    this.message = this.message || 'Email is currently in use.';
  }
}

export class FacebookUserAlreadyExists extends extendableError() {
  constructor(...params) {
    super(...params);
    this.message = this.message || 'An iFit account is already linked to this Facebook account.';
  }
}

export class FacebookIntegrationCancelled extends extendableError() {
  constructor(...params) {
    super(...params);
    this.message = this.message || 'Log in with Facebook cancelled';
  }
}

export class UnexpectedError extends extendableError() {
  constructor(...params) {
    super(...params);
    this.message = this.message || 'An unexpected error has occurred.';
  }
}

export class ActivationCodeError extends extendableError() {
  constructor(...params) {
    super(...params);
    this.message = this.message || 'That\'s not a valid code.';
  }
}
